<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="800"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <div>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="手机号"
          >
            <a-input
              placeholder="请输入手机号"
              :max-length="16"
              v-decorator="['mobile', validatorRules.mobile]"
            />
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="短信内容"
          >
            <a-textarea
              :max-length="100"
              v-decorator="['content', validatorRules.content]"
              placeholder="请输入短信内容"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </a-form-item>
        </div>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">立即发送</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { shortMessageAdd, shortMessageUrl } from '@/api/shortMessage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
export default {
  data() {
    return {
      title: '新增',
      visible: false,
      confirmLoading: false,
      model: {},
      typeText: '',
      short: null,
      value: '',
      yearPick: null,
      yearPickShow: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      validatorRules: {
        web: {
          rules: [
            {
              required: true,
              message: '请输入正确的官网网址!',
              pattern: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/
            }
          ]
        },
        content: { rules: [{ required: true, message: '请输入短信内容!' }] },
        // sex: { rules: [{ required: true, message: '请选择性别!' }] },
        mobile: {
          rules: [
            {
              required: true,
              message: '请输入正确的手机号!',
              pattern: /^0?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/
            }
          ]
        }
      },
      url: {
        add: process.env.VUE_APP_CMS_SMSBIZ + '/sms/send',
        edit:
          process.env.VUE_APP_CMS_PRODUCT + '/product/productsOrganization/edit'
      }
    };
  },
  components: {
    JDate,
    JDictSelectTag
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      console.log(record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'id', 'content', 'mobile'));
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    onChange() {},
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = Object.assign(this.model, values);
          console.log(this.model);
          if (!that.model.id) {
            shortMessageAdd(formData).then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok', that.model);
                that.close();
                that.confirmLoading = false;
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
          }

          // //时间格式化
          // httpAction(httpurl, formData, method).then((res) => {
          //   console.log(res)
          //   if (res.success) {
          //     that.$message.success(res.message)
          //     that.$emit('ok', that.model)
          //     that.confirmLoading = false
          //     that.close()
          //   } else {
          //     that.$message.warning(res.message)
          //     that.confirmLoading = false
          //   }
          // })
        }
      });
    },
    handleCancel() {
      this.close();
    },
    handleExportExcel() {
      shortMessageUrl().then(res => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        console.log(res, '>>>>>');
        // if (typeof window.navigator.msSaveBlob !== 'undefined') {
        //   window.navigator.msSaveBlob(
        //     new Blob([data], { type: 'application/vnd.ms-excel' }),
        //     fileName + '.xls'
        //   )
        // } else {
        //   let url = window.URL.createObjectURL(
        //     new Blob([data], { type: 'application/vnd.ms-excel' })
        //   )
        //   let link = document.createElement('a')
        //   link.style.display = 'none'
        //   link.href = url
        //   link.setAttribute('download', fileName + '.xls')
        //   document.body.appendChild(link)
        //   link.click()
        //   document.body.removeChild(link) //下载完成移除元素
        //   window.URL.revokeObjectURL(url) //释放掉blob对象
        // }
      });
    }
  }
};
</script>

<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
